import styled from 'styled-components';
import { HotPriceCircle } from '@lt/components/icons-react/userflow';
import { CurrencyFormat } from '@lt/components';

export const HotPriceIcon = styled(HotPriceCircle)`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCurrencyFormat: typeof CurrencyFormat = styled(CurrencyFormat)`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1em;
  text-decoration-line: line-through;
  color: #d0021b;
`;
